import { BoundedContent, Box } from '@vp/swan';

interface RecommendationsLayoutProps {
    children: React.ReactNode;
}

export function RecommendationsLayout({ children }: RecommendationsLayoutProps) {
    return (
        <BoundedContent>
            <Box paddingLeft={{ xs: 3, md: 0 }} paddingRight={{ xs: 3, md: 0 }}>
                {children}
            </Box>
        </BoundedContent>
    );
}
